// extracted by mini-css-extract-plugin
export default {"container":"MyBlogs_container__CzWmP","content":"MyBlogs_content__ojp67","msg":"MyBlogs_msg__WCewd","postBtn":"MyBlogs_postBtn__mvZg1"};